import { Box, Grid, Link, Stack, Typography } from "@mui/material";

export const FooterNavigation = () => {
  return (
    <Box sx={{ color: "white", p: 3, mt: 5 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="h6" gutterBottom>
            OUR PRODUCTS
          </Typography>
          <Stack display={"flex"} flexDirection={"column"} gap={1}>
            <Link
              underline="none"
              href="https://daveywater.com/au/products/"
              color="inherit"
            >
              All Products
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/products/pumps/"
              color="inherit"
            >
              Pumps
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/products/firefighter/"
              color="inherit"
            >
              Firefighters
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/products/pressure-tanks/"
              color="inherit"
            >
              Pressure Tanks
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/products/controllers/"
              color="inherit"
            >
              Controllers
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/products/commercial/"
              color="inherit"
            >
              Commercial
            </Link>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Typography color={"#2E2C2D"} variant="h6" gutterBottom>
            .
          </Typography>
          <Stack display={"flex"} flexDirection={"column"} gap={1}>
            <Link
              underline="none"
              href="https://daveywater.com/au/products/pool-pumps-filters/"
              color="inherit"
            >
              Pool Pumps & Filtration
            </Link>
            <Link
              underline="none"
              href="https://daveywater.com/au/products/chlorinators/"
              color="inherit"
            >
              Chlorinators
            </Link>
            <Link
              underline="none"
              href="https://daveywater.com/au/products/pool-spa-heaters/"
              color="inherit"
            >
              Heaters & Cleaners
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/products/accessories/"
              color="inherit"
            >
              Accessories
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/products/treatment-filtration/"
              color="inherit"
            >
              Treatment & Filtration
            </Link>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="h6" gutterBottom>
            SUPPORT
          </Typography>
          <Stack display={"flex"} flexDirection={"column"} gap={1}>
            <Link
              underline="none"
              href="https://daveywater.com/au/support/domestic-pump-sizing/"
              color="inherit"
            >
              Select the Right Pump
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/support/product-resources/"
              color="inherit"
            >
              Product Resources
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/microlenewatertest/"
              color="inherit"
            >
              Water Test
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/product-recall-and-safety/"
              color="inherit"
            >
              Product Recall & Safety
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/support/product-warranty/"
              color="inherit"
            >
              Warranty Information
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/support/contact-us/"
              color="inherit"
            >
              Contact Us
            </Link>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="h6" gutterBottom>
            OTHER
          </Typography>
          <Stack display={"flex"} flexDirection={"column"} gap={1}>
            <Link
              underline="none"
              href="https://daveywater.com/au/ecosalt-flow-switch-safety-recall/"
              color="inherit"
            >
              EcoSalt Flow Switch Safety Recall
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/dynadrive-product-safety-recall/"
              color="inherit"
            >
              DynaDrive Product Safety Recall
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/spa-quip-safety-recall/"
              color="inherit"
            >
              Spa Quip Safety Recall
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/litmos-coming-soon/"
              color="inherit"
            >
              Davey Learning & Development
            </Link>

            <Link
              underline="none"
              href="https://my.daveywater.com/#/login"
              color="inherit"
            >
              my.daveywater.com
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/privacy-policy/"
              color="inherit"
            >
              Privacy Policy
            </Link>

            <Link
              underline="none"
              href="https://daveywater.com/au/terms-and-conditions-of-sale/"
              color="inherit"
            >
              Terms and Conditions of Sale
            </Link>
          </Stack>
        </Grid>
      </Grid>
      <Box mt={3}>
        <Typography variant="body2" align="center">
          ©2024 Davey Water | All rights reserved
        </Typography>
      </Box>
    </Box>
  );
};
